import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setInitialQuota, setTermState } from 'context/reducer/quota'
import { RootState } from 'context'
import { QuotaState } from '../../../../../../../interfaces/quota/index'
import MobileTermsProps from './mobile'
import { DesktopTerms } from './desktop'
import Grid  from '@mui/material/Grid'

const Terms: React.FC<{isMobile: boolean}> = ({isMobile}) => {
  const { quotas } = useSelector<RootState, QuotaState>((state) => state.quota)
  const dispatch = useDispatch()
  const doubt = [
    ...quotas.map((quota) => {
      return {
        title: (
          <>
            {isMobile ?
              <div className="semibold"><strong >{quota.term} meses</strong> con cuotas de <strong>$ {quota.quota}*</strong> </div>
              :
              <strong className="semibold bp-mb-8">{quota.term} meses</strong>
            }
          </>
        ),
        subtitle: (
          <>
            {isMobile ?
              <div>
                Total a pagar:{' '}
                <strong className="semibold">$ {quota.total}*</strong>{' '}
              </div> :
              <>
                Cuotas: <strong className="semibold">$ {quota.quota}</strong> <br />
                Total: <strong className="semibold">$ {quota.total}</strong>{' '}
              </>
            }
          </>
        ),
        isCalculated: true,
        quotaText: quota.quota,
        capital: quota.capital,
        interes: quota.totalInterest,
        seguro: quota.seguro,
        total: quota.total,
        term: quota.term,
      }
    }),
    {
      title: (
        <>
          <strong className="semibold bp-mb-8">Otro</strong>
        </>
      ),
      subtitle: (
        <>
          <div className="semibold">Personaliza tu plazo</div>
        </>
      ),
      term: 'otro',
    },
  ]

  const [open, setOpen] = useState(3)
  useEffect(() => {
    const currentTerm = quotas[open]
    if (open !== -1 && open < quotas.length) {
      dispatch(setInitialQuota(currentTerm?.quota))
      dispatch(setTermState(`${currentTerm?.term}`))
    }
  }, [open, quotas, dispatch])

  const onClick = (value: any, isOpen: boolean) => {
    setOpen(value)
    if (isOpen) {
      setOpen(-1)
    }
  }

  return (
    <Grid
      container
      className="bp-mt-8"
      direction="row"
      justifyContent="space-between"
    >
      {isMobile ? (
        <MobileTermsProps
          onClick={onClick}
          open={open}
          doubt={doubt}
        />
      ) : (
        <DesktopTerms doubt={doubt} />
      )}
    </Grid>
  )
}

export default Terms